module.exports = __webpack_public_path__ + "img/yw1.437f158e.png";